import React from 'react';

const PieChart = ({ data, title, colors, size = 200, showLegend = true, showPercentage = true }) => {
  if (!data || data.length === 0) {
    return (
      <div className="text-center py-4">
        <p className="text-slate-500">Aucune donnée disponible</p>
      </div>
    );
  }

  const total = data.reduce((sum, item) => sum + item.value, 0);
  const radius = size / 2;
  const circumference = 2 * Math.PI * radius;
  
  let accumulatedPercentage = 0;

  return (
    <div className="flex flex-col items-center">
      {title && <h6 className="font-semibold mb-4 text-slate-700">{title}</h6>}
      
      <div className="relative" style={{ width: size, height: size }}>
        <svg width={size} height={size} className="transform -rotate-90">
          {data.map((item, index) => {
            const percentage = total > 0 ? (item.value / total) * 100 : 0;
            const strokeDasharray = `${(percentage * circumference) / 100} ${circumference}`;
            const strokeDashoffset = -accumulatedPercentage;
            accumulatedPercentage += (percentage * circumference) / 100;

            return (
              <circle
                key={item.label}
                cx={radius}
                cy={radius}
                r={radius - 2}
                fill="transparent"
                stroke={colors ? colors[index % colors.length] : getDefaultColor(index)}
                strokeWidth="4"
                strokeDasharray={strokeDasharray}
                strokeDashoffset={strokeDashoffset}
                className="transition-all duration-500"
              />
            );
          })}
        </svg>
        
        {/* Centre du graphique avec le total */}
        <div className="absolute inset-0 flex items-center justify-center">
          <div className="text-center">
            <div className="text-2xl font-bold text-slate-800">{total}</div>
            {showPercentage && <div className="text-xs text-slate-500">Total</div>}
          </div>
        </div>
      </div>

      {/* Légende */}
      {showLegend && (
        <div className="mt-4 space-y-2">
          {data.map((item, index) => {
            const percentage = total > 0 ? ((item.value / total) * 100).toFixed(1) : 0;
            return (
              <div key={item.label} className="flex items-center justify-between text-sm">
                <div className="flex items-center">
                  <div 
                    className="w-3 h-3 rounded-full mr-2"
                    style={{ backgroundColor: colors ? colors[index % colors.length] : getDefaultColor(index) }}
                  ></div>
                  <span className="text-slate-700">{item.label}</span>
                </div>
                <div className="text-slate-600">
                  {item.value} {showPercentage && `(${percentage}%)`}
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
};

// Couleurs par défaut pour les graphiques
const getDefaultColor = (index) => {
  const colors = [
    '#3b82f6', // blue
    '#10b981', // green
    '#f59e0b', // amber
    '#ef4444', // red
    '#8b5cf6', // violet
    '#06b6d4', // cyan
    '#f97316', // orange
    '#84cc16', // lime
  ];
  return colors[index % colors.length];
};

export default PieChart;